import React, { useState } from "react";
import { Col, Collapse, Typography } from "antd";
import Panelheader from "../panelheader/panelheader";
import FormFields from "./formfields";

const { Paragraph } = Typography;
const { Panel } = Collapse;

const PanelAdmin = (props) => {
  const _isEditing = () => {
    setisEditing((prev) => !prev);
  };

  const [isEditing, setisEditing] = useState(false);

  return (
    <Panel
      {...props}
      showArrow={false}
      header={
        <Panelheader
          isAdmin
          _index={props.index}
          _title={`${props.index + 1}. ${props.header}`}
          _isEditing={_isEditing}
          _isEditingValue={isEditing}
          _activekeys={props._activeKeys}
        />
      }
      style={{ textAlign: "left" }}
    >
      <Col span={21}>
        {isEditing ? (
          <FormFields {...props} _isEditing={_isEditing} />
        ) : (
          <Paragraph>{props.text}</Paragraph>
        )}
      </Col>
    </Panel>
  );
};

export default PanelAdmin;
